import axios from 'axios';
import RestService from '../../helpers/RestService';
import moment from 'moment';
import {toastr} from 'react-redux-toastr'

axios.defaults.headers.common = {
  'Accept': 'application/json, text/plain',
  'X-CSRF-Token': RestService.getCsrfToken(),
  'X-Requested-With' : 'XMLHttpRequest',
};

axios.defaults.headers.post['Content-Type'] = 'application/json';

export function getFolders() {
  return async (dispatch) => {
    try {
      const {data} = await axios.get('/api/folders/get');

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'GET_FOLDERS', data: payload})
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      dispatch({type: 'GET_FOLDERS', data: []})
      return Promise.reject({message: 'Bag request'})
      
    }
  }
}

export function createFolder(body) {
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/folder/post', {
        ...body, 
      });

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'NEW_FOLDER', data: payload});
        return data;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      return Promise.reject({message: 'Bag request'})      
    }
  }
}

export function createPresentation(body) {
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/presentation/post', {
        ...body, 
      });

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'NEW_FOLDER_PRESENTATION', data: payload});
        return data;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      return Promise.reject({message: 'Bag request'})      
    }
  }
}

export function updatePresentation(body) {
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/presentation/patch', {
        ...body, 
      });

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'UPDATE_FOLDER_PRESENTATION', data: payload});
        return data;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      return Promise.reject({message: 'Bag request'})      
    }
  }
}


export function copyPresentation(body) {
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/presentation/copy', {
        ...body, 
      });

      if(data.errcode == 200) {
        return true;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      return Promise.reject({message: 'Bag request'})      
    }
  }
}

export function deletePresentation(id) {
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/presentation/delete', {id});

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'DELETE_FOLDER_PRESENTATION', data: id});
        return data;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      return Promise.reject({message: 'Bag request'})      
    }
  }
}


export function deleteFolder(id) {
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/folder/delete', { id });

      if(data.errcode == 200) {
        dispatch({type: 'DELETE_FOLDER', data: id});
        return data.payload;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
     
    } catch (error) {
      return Promise.reject({message: 'Bag request'})
    }
  }
}


export function updateFolder(body) {
  return async (dispatch) => {
    try {
      
      const {data} = await axios.post('/api/folder/patch', {
        ...body, 
      });

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'UPDATE_FOLDER', data: payload});
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      return Promise.reject({message: 'Bag request'}) 
    }
  }
}


export function setFolderItem(data) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_FOLDER', data})
      return data;
    } catch (error) {
    }
  }
}

export function getFolderPresentation(id = 0, not_loader=false) {
  return async (dispatch) => {
    try {
      if(!not_loader){
        dispatch({type: 'SET_FOLDER_PRESENTATIONS_LOADED', data: false});
      }
      const {data} = await axios.post('/api/folder/presentations', {id});

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'GET_FOLDER_PRESENTATIONS', data: payload});
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
    }
  }
}




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Presentations/actions.js